<template>
  <v-app id="inspire">
    <v-navigation-drawer
      v-model="drawer"
      fixed
      app
      class="tw-text-left tw-text-white tw-eko-dark"
      color="#212452"
      width="250"
    >
      <img
        class="my-img tw-mx-auto tw-mt-4 tw-mb-8"
        src="https://res.cloudinary.com/dldd8ucby/image/upload/v1580808183/Eko%20Carbon/logo_2.png"
      />

      <div id="tw-p-4">
        <router-link to="/admin">
          <p class="tw-text-white tw-mx-8 tw-my-6">
            <i class="fas fa-home tw-pr-1 md:tw-pr-3"></i> Home
          </p>
        </router-link>
        <router-link to="/admin/projects">
          <p class="tw-text-white tw-mx-8 tw-my-6">
            <i class="fas fa-folder tw-pr-1 md:tw-pr-3"></i>
            Projects
          </p>
        </router-link>
        <!-- <router-link to="/admin/solutions/me">
          <p class="tw-text-white tw-mx-8 tw-my-6">
            <i class="fas fa-chart-bar tw-pr-1 md:tw-pr-3"></i>Trades
          </p>
        </router-link> -->
        <!-- <router-link to="/admin/solutions/me">
          <p class="tw-text-white tw-mx-8 tw-my-6">
            <i class="fas fa-money-bill tw-pr-1 md:tw-pr-3"></i>
            Payments
          </p>
        </router-link> -->
        <router-link to="/admin/profile">
          <p class="tw-text-white tw-mx-8 tw-my-6">
            <i class="fas fa-user tw-pr-1 md:tw-pr-3"></i>
            Profile
          </p>
        </router-link>
        <router-link to="/admin/register/admin">
          <p class="tw-text-white tw-mx-8 tw-my-6">
            <i class="fas fa-plus-square tw-pr-1 md:tw-pr-3"></i>

            Create Admin
          </p>
        </router-link>

        <router-link to="/admin/sectors">
          <p class="tw-text-white tw-mx-8 tw-my-6">
            <i class="fas fa-bezier-curve tw-pr-1 md:tw-pr-3"></i>

            Sectors
          </p>
        </router-link>
        <p
          @click="logOut"
          class="tw-block tw-cursor-pointer tw-text-white tw-mx-8 tw-my-6 tw-align-middle tw-text-lg tw-text-white tw-no-underline hover:tw-text-pink hover:tw-border-pink"
        >
          <i class="fas fa-link tw-pr-1 md:tw-pr-3"></i
          ><span class="tw-pb-1 md:tw-pb-0">Logout</span>
        </p>
      </div>
    </v-navigation-drawer>
    <v-content>
      <div class="body">
        <template>
          <div>
            <v-app-bar color="white">
              <v-app-bar-nav-icon
                color="#2C316C"
                class="tw-hidden md:tw-block"
                @click.stop="drawer = !drawer"
              ></v-app-bar-nav-icon>

              <v-toolbar-title>Eko Carbon Exchange</v-toolbar-title>

              <v-spacer></v-spacer>

              <i class="fas fa-user-circle tw-text-3xl tw-text-idea-dark"></i>

              <v-menu left bottom>
                <template v-slot:activator="{ on }">
                  <v-btn icon v-on="on">
                    <v-icon>mdi-dots-vertical</v-icon>
                  </v-btn>
                </template>

                <v-list>
                  <v-list-item>
                    <v-list-item-title class="tw-cursor-pointer" @click="logOut"
                      >Logout</v-list-item-title
                    >
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-app-bar>
          </div>
        </template>
        <div class="tw-mx-4">
          <router-view></router-view>
        </div>
      </div>
    </v-content>
  </v-app>
</template>

<script>
export default {
  components: {
    // Sidebar
  },
  data() {
    return {
      user: {},
      token: "",
      drawer: true,
      admin: null,
    };
  },
  methods: {
    logOut() {
      localStorage.removeItem("eko-carbon-user");
      localStorage.removeItem("eko-carbon-token");
      this.$router.push("/auth/login");
    },
  },
  mounted() {
    this.token = localStorage.getItem("eko-carbon-token");
    this.user = JSON.parse(localStorage.getItem("eko-carbon-user"));
    if (!this.user || !this.token) {
      this.$router.push("/auth/login");
    }

    if (this.user.userType != "admin") {
      this.$swal("Error!", "You need to login as an admin", "error");
      this.logOut();
    }
  },
};
</script>

<style lang="css" scoped>
.my-img {
  width: 80%;
}
</style>
